module.exports = {"$schema":"http://iglucentral.com/schemas/com.snowplowanalytics.self-desc/schema/jsonschema/1-0-0#","self":{"vendor":"com.codecombat","name":"starter_license_upsell_banner_viewed","format":"jsonschema","version":"1-0-0"},"type":"object","properties":{"user":{"type":"string","pattern":"^[a-z0-9]{24}$","maxLength":24,"minLength":24}},"required":["user"],"additionalProperties":false}


//////////////////
// WEBPACK FOOTER
// ./app/schemas/events/starter_license_upsell_banner_viewed.json
// module id = 582
// module chunks = 100